const Countries = [
	{
		"name": "Afghanistan",
		"nationality": "Afghan",
		"handle": "AF"
	},
	{
		"name": "Albania",
		"nationality": "Albanian",
		"handle": "AL"
	},
	{
		"name": "Algeria",
		"nationality": "Algerian",
		"handle": "DZ"
	},
	{
		"name": "American Samoa",
		"nationality": "American Samoan",
		"handle": "AS"
	},
	{
		"name": "Andorra",
		"nationality": "Andorran",
		"handle": "AD"
	},
	{
		"name": "Angola",
		"nationality": "Angolan",
		"handle": "AO"
	},
	{
		"name": "Anguilla",
		"nationality": "Anguillan",
		"handle": "AI"
	},
	{
		"name": "Antarctica",
		"nationality": "Antarctic",
		"handle": "AQ"
	},
	{
		"name": "Antigua and Barbuda",
		"nationality": "Antiguan or Barbudan",
		"handle": "AG"
	},
	{
		"name": "Argentina",
		"nationality": "Argentine",
		"handle": "AR"
	},
	{
		"name": "Armenia",
		"nationality": "Armenian",
		"handle": "AM"
	},
	{
		"name": "Aruba",
		"nationality": "Aruban",
		"handle": "AW"
	},
	{
		"name": "Australia",
		"nationality": "Australian",
		"handle": "AU"
	},
	{
		"name": "Austria",
		"nationality": "Austrian",
		"handle": "AT"
	},
	{
		"name": "Azerbaijan",
		"nationality": "Azerbaijani, Azeri",
		"handle": "AZ"
	},
	{
		"name": "Bahamas",
		"nationality": "Bahamian",
		"handle": "BS"
	},
	{
		"name": "Bahrain",
		"nationality": "Bahraini",
		"handle": "BH"
	},
	{
		"name": "Bangladesh",
		"nationality": "Bangladeshi",
		"handle": "BD"
	},
	{
		"name": "Barbados",
		"nationality": "Barbadian",
		"handle": "BB"
	},
	{
		"name": "Belarus",
		"nationality": "Belarusian",
		"handle": "BY"
	},
	{
		"name": "Belgium",
		"nationality": "Belgian",
		"handle": "BE"
	},
	{
		"name": "Belize",
		"nationality": "Belizean",
		"handle": "BZ"
	},
	{
		"name": "Benin",
		"nationality": "Beninese, Beninois",
		"handle": "BJ"
	},
	{
		"name": "Bermuda",
		"nationality": "Bermudian, Bermudan",
		"handle": "BM"
	},
	{
		"name": "Bhutan",
		"nationality": "Bhutanese",
		"handle": "BT"
	},
	{
		"name": "Bolivia (Plurinational State of)",
		"nationality": "Bolivian",
		"handle": "BO"
	},
	{
		"name": "Bonaire, Sint Eustatius and Saba",
		"nationality": "Bonaire",
		"handle": "BQ"
	},
	{
		"name": "Bosnia and Herzegovina",
		"nationality": "Bosnian or Herzegovinian",
		"handle": "BA"
	},
	{
		"name": "Botswana",
		"nationality": "Motswana, Botswanan",
		"handle": "BW"
	},
	{
		"name": "Bouvet Island",
		"nationality": "Bouvet Island",
		"handle": "BV"
	},
	{
		"name": "Brazil",
		"nationality": "Brazilian",
		"handle": "BR"
	},
	{
		"name": "British Indian Ocean Territory",
		"nationality": "BIOT",
		"handle": "IO"
	},
	{
		"name": "Brunei Darussalam",
		"nationality": "Bruneian",
		"handle": "BN"
	},
	{
		"name": "Bulgaria",
		"nationality": "Bulgarian",
		"handle": "BG"
	},
	{
		"name": "Burkina Faso",
		"nationality": "Burkinabé",
		"handle": "BF"
	},
	{
		"name": "Burundi",
		"nationality": "Burundian",
		"handle": "BI"
	},
	{
		"name": "Cabo Verde",
		"nationality": "Cabo Verdean",
		"handle": "CV"
	},
	{
		"name": "Cambodia",
		"nationality": "Cambodian",
		"handle": "KH"
	},
	{
		"name": "Cameroon",
		"nationality": "Cameroonian",
		"handle": "CM"
	},
	{
		"name": "Canada",
		"nationality": "Canadian",
		"handle": "CA"
	},
	{
		"name": "Cayman Islands",
		"nationality": "Caymanian",
		"handle": "KY"
	},
	{
		"name": "Central African Republic",
		"nationality": "Central African",
		"handle": "CF"
	},
	{
		"name": "Chad",
		"nationality": "Chadian",
		"handle": "TD"
	},
	{
		"name": "Chile",
		"nationality": "Chilean",
		"handle": "CL"
	},
	{
		"name": "China",
		"nationality": "Chinese",
		"handle": "CN"
	},
	{
		"name": "Christmas Island",
		"nationality": "Christmas Island",
		"handle": "CX"
	},
	{
		"name": "Cocos (Keeling) Islands",
		"nationality": "Cocos Island",
		"handle": "CC"
	},
	{
		"name": "Colombia",
		"nationality": "Colombian",
		"handle": "CO"
	},
	{
		"name": "Comoros",
		"nationality": "Comoran, Comorian",
		"handle": "KM"
	},
	{
		"name": "Congo (Democratic Republic of the)",
		"nationality": "Congolese",
		"handle": "CD"
	},
	{
		"name": "Congo (Republic of the)",
		"nationality": "Congolese",
		"handle": "CG"
	},
	{
		"name": "Cook Islands",
		"nationality": "Cook Island",
		"handle": "CK"
	},
	{
		"name": "Costa Rica",
		"nationality": "Costa Rican",
		"handle": "CR"
	},
	{
		"name": "Crimea Region",
		"nationality": "Crimean",
		"handle": "RC"
	},
	{
		"name": "Croatia",
		"nationality": "Croatian",
		"handle": "HR"
	},
	{
		"name": "Cuba",
		"nationality": "Cuban",
		"handle": "CU"
	},
	{
		"name": "Curaçao",
		"nationality": "Curaçaoan",
		"handle": "CW"
	},
	{
		"name": "Cyprus",
		"nationality": "Cypriot",
		"handle": "CY"
	},
	{
		"name": "Czech Republic",
		"nationality": "Czech",
		"handle": "CZ"
	},
	{
		"name": "Côte d'Ivoire",
		"nationality": "Ivorian",
		"handle": "CI"
	},
	{
		"name": "Denmark",
		"nationality": "Danish",
		"handle": "DK"
	},
	{
		"name": "Djibouti",
		"nationality": "Djiboutian",
		"handle": "DJ"
	},
	{
		"name": "Dominica",
		"nationality": "Dominican",
		"handle": "DM"
	},
	{
		"name": "Dominican Republic",
		"nationality": "Dominican",
		"handle": "DO"
	},
	{
		"name": "Ecuador",
		"nationality": "Ecuadorian",
		"handle": "EC"
	},
	{
		"name": "Egypt",
		"nationality": "Egyptian",
		"handle": "EG"
	},
	{
		"name": "El Salvador",
		"nationality": "Salvadoran",
		"handle": "SV"
	},
	{
		"name": "Equatorial Guinea",
		"nationality": "Equatorial Guinean, Equatoguinean",
		"handle": "GQ"
	},
	{
		"name": "Eritrea",
		"nationality": "Eritrean",
		"handle": "ER"
	},
	{
		"name": "Estonia",
		"nationality": "Estonian",
		"handle": "EE"
	},
	{
		"name": "Ethiopia",
		"nationality": "Ethiopian",
		"handle": "ET"
	},
	{
		"name": "Falkland Islands (Malvinas)",
		"nationality": "Falkland Island",
		"handle": "FK"
	},
	{
		"name": "Faroe Islands",
		"nationality": "Faroese",
		"handle": "FO"
	},
	{
		"name": "Fiji",
		"nationality": "Fijian",
		"handle": "FJ"
	},
	{
		"name": "Finland",
		"nationality": "Finnish",
		"handle": "FI"
	},
	{
		"name": "France",
		"nationality": "French",
		"handle": "FR"
	},
	{
		"name": "French Guiana",
		"nationality": "French Guianese",
		"handle": "GF"
	},
	{
		"name": "French Polynesia",
		"nationality": "French Polynesian",
		"handle": "PF"
	},
	{
		"name": "French Southern Territories",
		"nationality": "French Southern Territories",
		"handle": "TF"
	},
	{
		"name": "Gabon",
		"nationality": "Gabonese",
		"handle": "GA"
	},
	{
		"name": "Gambia",
		"nationality": "Gambian",
		"handle": "GM"
	},
	{
		"name": "Georgia",
		"nationality": "Georgian",
		"handle": "GE"
	},
	{
		"name": "Germany",
		"nationality": "German",
		"handle": "DE"
	},
	{
		"name": "Ghana",
		"nationality": "Ghanaian",
		"handle": "GH"
	},
	{
		"name": "Gibraltar",
		"nationality": "Gibraltar",
		"handle": "GI"
	},
	{
		"name": "Greece",
		"nationality": "Greek, Hellenic",
		"handle": "GR"
	},
	{
		"name": "Greenland",
		"nationality": "Greenlandic",
		"handle": "GL"
	},
	{
		"name": "Grenada",
		"nationality": "Grenadian",
		"handle": "GD"
	},
	{
		"name": "Guadeloupe",
		"nationality": "Guadeloupe",
		"handle": "GP"
	},
	{
		"name": "Guam",
		"nationality": "Guamanian, Guambat",
		"handle": "GU"
	},
	{
		"name": "Guatemala",
		"nationality": "Guatemalan",
		"handle": "GT"
	},
	{
		"name": "Guernsey",
		"nationality": "Channel Island",
		"handle": "GG"
	},
	{
		"name": "Guinea",
		"nationality": "Guinean",
		"handle": "GN"
	},
	{
		"name": "Guinea-Bissau",
		"nationality": "Bissau-Guinean",
		"handle": "GW"
	},
	{
		"name": "Guyana",
		"nationality": "Guyanese",
		"handle": "GY"
	},
	{
		"name": "Haiti",
		"nationality": "Haitian",
		"handle": "HT"
	},
	{
		"name": "Heard Island and McDonald Islands",
		"nationality": "Heard Island or McDonald Islands",
		"handle": "HM"
	},
	{
		"name": "Honduras",
		"nationality": "Honduran",
		"handle": "HN"
	},
	{
		"name": "Hong Kong",
		"nationality": "Hong Kong, Hong Kongese",
		"handle": "HK"
	},
	{
		"name": "Hungary",
		"nationality": "Hungarian, Magyar",
		"handle": "HU"
	},
	{
		"name": "Iceland",
		"nationality": "Icelandic",
		"handle": "IS"
	},
	{
		"name": "India",
		"nationality": "Indian",
		"handle": "IN"
	},
	{
		"name": "Indonesia",
		"nationality": "Indonesian",
		"handle": "ID"
	},
	{
		"name": "Iran",
		"nationality": "Iranian, Persian",
		"handle": "IR"
	},
	{
		"name": "Iraq",
		"nationality": "Iraqi",
		"handle": "IQ"
	},
	{
		"name": "Ireland",
		"nationality": "Irish",
		"handle": "IE"
	},
	{
		"name": "Isle of Man",
		"nationality": "Manx",
		"handle": "IM"
	},
	{
		"name": "Israel",
		"nationality": "Israeli",
		"handle": "IL"
	},
	{
		"name": "Italy",
		"nationality": "Italian",
		"handle": "IT"
	},
	{
		"name": "Jamaica",
		"nationality": "Jamaican",
		"handle": "JM"
	},
	{
		"name": "Japan",
		"nationality": "Japanese",
		"handle": "JP"
	},
	{
		"name": "Jersey",
		"nationality": "Channel Island",
		"handle": "JE"
	},
	{
		"name": "Jordan",
		"nationality": "Jordanian",
		"handle": "JO"
	},
	{
		"name": "Kazakhstan",
		"nationality": "Kazakhstani, Kazakh",
		"handle": "KZ"
	},
	{
		"name": "Kenya",
		"nationality": "Kenyan",
		"handle": "KE"
	},
	{
		"name": "Kiribati",
		"nationality": "I-Kiribati",
		"handle": "KI"
	},
	{
		"name": "Korea (Democratic People's Republic of)",
		"nationality": "North Korean",
		"handle": "KP"
	},
	{
		"name": "Korea (Republic of)",
		"nationality": "South Korean",
		"handle": "KR"
	},
	{
		"name": "Kozovo",
		"nationality": "Kosovan",
		"handle": "XK"
	},
	{
		"name": "Kuwait",
		"nationality": "Kuwaiti",
		"handle": "KW"
	},
	{
		"name": "Kyrgyzstan",
		"nationality": "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz",
		"handle": "KG"
	},
	{
		"name": "Lao People's Democratic Republic",
		"nationality": "Lao, Laotian",
		"handle": "LA"
	},
	{
		"name": "Latvia",
		"nationality": "Latvian",
		"handle": "LV"
	},
	{
		"name": "Lebanon",
		"nationality": "Lebanese",
		"handle": "LB"
	},
	{
		"name": "Lesotho",
		"nationality": "Basotho",
		"handle": "LS"
	},
	{
		"name": "Liberia",
		"nationality": "Liberian",
		"handle": "LR"
	},
	{
		"name": "Libya",
		"nationality": "Libyan",
		"handle": "LY"
	},
	{
		"name": "Liechtenstein",
		"nationality": "Liechtenstein",
		"handle": "LI"
	},
	{
		"name": "Lithuania",
		"nationality": "Lithuanian",
		"handle": "LT"
	},
	{
		"name": "Luxembourg",
		"nationality": "Luxembourg, Luxembourgish",
		"handle": "LU"
	},
	{
		"name": "Macao",
		"nationality": "Macanese, Chinese",
		"handle": "MO"
	},
	{
		"name": "Macedonia (the former Yugoslav Republic of)",
		"nationality": "Macedonian",
		"handle": "MK"
	},
	{
		"name": "Madagascar",
		"nationality": "Malagasy",
		"handle": "MG"
	},
	{
		"name": "Malawi",
		"nationality": "Malawian",
		"handle": "MW"
	},
	{
		"name": "Malaysia",
		"nationality": "Malaysian",
		"handle": "MY"
	},
	{
		"name": "Maldives",
		"nationality": "Maldivian",
		"handle": "MV"
	},
	{
		"name": "Mali",
		"nationality": "Malian, Malinese",
		"handle": "ML"
	},
	{
		"name": "Malta",
		"nationality": "Maltese",
		"handle": "MT"
	},
	{
		"name": "Marshall Islands",
		"nationality": "Marshallese",
		"handle": "MH"
	},
	{
		"name": "Martinique",
		"nationality": "Martiniquais, Martinican",
		"handle": "MQ"
	},
	{
		"name": "Mauritania",
		"nationality": "Mauritanian",
		"handle": "MR"
	},
	{
		"name": "Mauritius",
		"nationality": "Mauritian",
		"handle": "MU"
	},
	{
		"name": "Mayotte",
		"nationality": "Mahoran",
		"handle": "YT"
	},
	{
		"name": "Mexico",
		"nationality": "Mexican",
		"handle": "MX"
	},
	{
		"name": "Micronesia (Federated States of)",
		"nationality": "Micronesian",
		"handle": "FM"
	},
	{
		"name": "Moldova (Republic of)",
		"nationality": "Moldovan",
		"handle": "MD"
	},
	{
		"name": "Monaco",
		"nationality": "Monégasque, Monacan",
		"handle": "MC"
	},
	{
		"name": "Mongolia",
		"nationality": "Mongolian",
		"handle": "MN"
	},
	{
		"name": "Montenegro",
		"nationality": "Montenegrin",
		"handle": "ME"
	},
	{
		"name": "Montserrat",
		"nationality": "Montserratian",
		"handle": "MS"
	},
	{
		"name": "Morocco",
		"nationality": "Moroccan",
		"handle": "MA"
	},
	{
		"name": "Mozambique",
		"nationality": "Mozambican",
		"handle": "MZ"
	},
	{
		"name": "Myanmar",
		"nationality": "Burmese",
		"handle": "MM"
	},
	{
		"name": "Namibia",
		"nationality": "Namibian",
		"handle": "NA"
	},
	{
		"name": "Nauru",
		"nationality": "Nauruan",
		"handle": "NR"
	},
	{
		"name": "Nepal",
		"nationality": "Nepali, Nepalese",
		"handle": "NP"
	},
	{
		"name": "Netherlands",
		"nationality": "Dutch, Netherlandic",
		"handle": "NL"
	},
	{
		"name": "New Caledonia",
		"nationality": "New Caledonian",
		"handle": "NC"
	},
	{
		"name": "New Zealand",
		"nationality": "New Zealand, NZ",
		"handle": "NZ"
	},
	{
		"name": "Nicaragua",
		"nationality": "Nicaraguan",
		"handle": "NI"
	},
	{
		"name": "Niger",
		"nationality": "Nigerien",
		"handle": "NE"
	},
	{
		"name": "Nigeria",
		"nationality": "Nigerian",
		"handle": "NG"
	},
	{
		"name": "Niue",
		"nationality": "Niuean",
		"handle": "NU"
	},
	{
		"name": "Norfolk Island",
		"nationality": "Norfolk Island",
		"handle": "NF"
	},
	{
		"name": "Northern Mariana Islands",
		"nationality": "Northern Marianan",
		"handle": "MP"
	},
	{
		"name": "Norway",
		"nationality": "Norwegian",
		"handle": "NO"
	},
	{
		"name": "Oman",
		"nationality": "Omani",
		"handle": "OM"
	},
	{
		"name": "Pakistan",
		"nationality": "Pakistani",
		"handle": "PK"
	},
	{
		"name": "Palau",
		"nationality": "Palauan",
		"handle": "PW"
	},
	{
		"name": "Palestine, State of",
		"nationality": "Palestinian",
		"handle": "PS"
	},
	{
		"name": "Panama",
		"nationality": "Panamanian",
		"handle": "PA"
	},
	{
		"name": "Papua New Guinea",
		"nationality": "Papua New Guinean, Papuan",
		"handle": "PG"
	},
	{
		"name": "Paraguay",
		"nationality": "Paraguayan",
		"handle": "PY"
	},
	{
		"name": "Peru",
		"nationality": "Peruvian",
		"handle": "PE"
	},
	{
		"name": "Philippines",
		"nationality": "Philippine, Filipino",
		"handle": "PH"
	},
	{
		"name": "Pitcairn",
		"nationality": "Pitcairn Island",
		"handle": "PN"
	},
	{
		"name": "Poland",
		"nationality": "Polish",
		"handle": "PL"
	},
	{
		"name": "Portugal",
		"nationality": "Portuguese",
		"handle": "PT"
	},
	{
		"name": "Puerto Rico",
		"nationality": "Puerto Rican",
		"handle": "PR"
	},
	{
		"name": "Qatar",
		"nationality": "Qatari",
		"handle": "QA"
	},
	{
		"name": "Romania",
		"nationality": "Romanian",
		"handle": "RO"
	},
	{
		"name": "Russian Federation",
		"nationality": "Russian",
		"handle": "RU"
	},
	{
		"name": "Rwanda",
		"nationality": "Rwandan",
		"handle": "RW"
	},
	{
		"name": "Réunion",
		"nationality": "Réunionese, Réunionnais",
		"handle": "RE"
	},
	{
		"name": "Saint Barthélemy",
		"nationality": "Barthélemois",
		"handle": "BL"
	},
	{
		"name": "Saint Helena, Ascension and Tristan da Cunha",
		"nationality": "Saint Helenian",
		"handle": "SH"
	},
	{
		"name": "Saint Kitts and Nevis",
		"nationality": "Kittitian or Nevisian",
		"handle": "KN"
	},
	{
		"name": "Saint Lucia",
		"nationality": "Saint Lucian",
		"handle": "LC"
	},
	{
		"name": "Saint Martin (French part)",
		"nationality": "Saint-Martinoise",
		"handle": "MF"
	},
	{
		"name": "Saint Pierre and Miquelon",
		"nationality": "Saint-Pierrais or Miquelonnais",
		"handle": "PM"
	},
	{
		"name": "Saint Vincent and the Grenadines",
		"nationality": "Saint Vincentian, Vincentian",
		"handle": "VC"
	},
	{
		"name": "Samoa",
		"nationality": "Samoan",
		"handle": "WS"
	},
	{
		"name": "San Marino",
		"nationality": "Sammarinese",
		"handle": "SM"
	},
	{
		"name": "Sao Tome and Principe",
		"nationality": "São Toméan",
		"handle": "ST"
	},
	{
		"name": "Saudi Arabia",
		"nationality": "Saudi, Saudi Arabian",
		"handle": "SA"
	},
	{
		"name": "Senegal",
		"nationality": "Senegalese",
		"handle": "SN"
	},
	{
		"name": "Serbia",
		"nationality": "Serbian",
		"handle": "RS"
	},
	{
		"name": "Seychelles",
		"nationality": "Seychellois",
		"handle": "SC"
	},
	{
		"name": "Sierra Leone",
		"nationality": "Sierra Leonean",
		"handle": "SL"
	},
	{
		"name": "Singapore",
		"nationality": "Singaporean",
		"handle": "SG"
	},
	{
		"name": "Sint Maarten (Dutch part)",
		"nationality": "Sint Maarten",
		"handle": "SX"
	},
	{
		"name": "Slovakia",
		"nationality": "Slovak",
		"handle": "SK"
	},
	{
		"name": "Slovenia",
		"nationality": "Slovenian, Slovene",
		"handle": "SI"
	},
	{
		"name": "Solomon Islands",
		"nationality": "Solomon Island",
		"handle": "SB"
	},
	{
		"name": "Somalia",
		"nationality": "Somali, Somalian",
		"handle": "SO"
	},
	{
		"name": "South Africa",
		"nationality": "South African",
		"handle": "ZA"
	},
	{
		"name": "South Georgia and the South Sandwich Islands",
		"nationality": "South Georgia or South Sandwich Islands",
		"handle": "GS"
	},
	{
		"name": "South Sudan",
		"nationality": "South Sudanese",
		"handle": "SS"
	},
	{
		"name": "Spain",
		"nationality": "Spanish",
		"handle": "ES"
	},
	{
		"name": "Sri Lanka",
		"nationality": "Sri Lankan",
		"handle": "LK"
	},
	{
		"name": "Sudan",
		"nationality": "Sudanese",
		"handle": "SD"
	},
	{
		"name": "Suriname",
		"nationality": "Surinamese",
		"handle": "SR"
	},
	{
		"name": "Svalbard and Jan Mayen",
		"nationality": "Svalbard",
		"handle": "SJ"
	},
	{
		"name": "Swaziland",
		"nationality": "Swazi",
		"handle": "SZ"
	},
	{
		"name": "Sweden",
		"nationality": "Swedish",
		"handle": "SE"
	},
	{
		"name": "Switzerland",
		"nationality": "Swiss",
		"handle": "CH"
	},
	{
		"name": "Syrian Arab Republic",
		"nationality": "Syrian",
		"handle": "SY"
	},
	{
		"name": "Taiwan, Province of China",
		"nationality": "Chinese, Taiwanese",
		"handle": "TW"
	},
	{
		"name": "Tajikistan",
		"nationality": "Tajikistani",
		"handle": "TJ"
	},
	{
		"name": "Tanzania, United Republic of",
		"nationality": "Tanzanian",
		"handle": "TZ"
	},
	{
		"name": "Thailand",
		"nationality": "Thai",
		"handle": "TH"
	},
	{
		"name": "Timor-Leste",
		"nationality": "Timorese",
		"handle": "TL"
	},
	{
		"name": "Togo",
		"nationality": "Togolese",
		"handle": "TG"
	},
	{
		"name": "Tokelau",
		"nationality": "Tokelauan",
		"handle": "TK"
	},
	{
		"name": "Tonga",
		"nationality": "Tongan",
		"handle": "TO"
	},
	{
		"name": "Trinidad and Tobago",
		"nationality": "Trinidadian or Tobagonian",
		"handle": "TT"
	},
	{
		"name": "Tunisia",
		"nationality": "Tunisian",
		"handle": "TN"
	},
	{
		"name": "Turkey",
		"nationality": "Turkish",
		"handle": "TR"
	},
	{
		"name": "Turkmenistan",
		"nationality": "Turkmen",
		"handle": "TM"
	},
	{
		"name": "Turks and Caicos Islands",
		"nationality": "Turks and Caicos Island",
		"handle": "TC"
	},
	{
		"name": "Tuvalu",
		"nationality": "Tuvaluan",
		"handle": "TV"
	},
	{
		"name": "Uganda",
		"nationality": "Ugandan",
		"handle": "UG"
	},
	{
		"name": "Ukraine",
		"nationality": "Ukrainian",
		"handle": "UA"
	},
	{
		"name": "United Arab Emirates",
		"nationality": "Emirati, Emirian, Emiri",
		"handle": "AE"
	},
	{
		"name": "United Kingdom of Great Britain and Northern Ireland",
		"nationality": "British, UK",
		"handle": "GB"
	},
	{
		"name": "United States Minor Outlying Islands",
		"nationality": "American",
		"handle": "UM"
	},
	{
		"name": "United States of America",
		"nationality": "American",
		"handle": "US"
	},
	{
		"name": "Uruguay",
		"nationality": "Uruguayan",
		"handle": "UY"
	},
	{
		"name": "Uzbekistan",
		"nationality": "Uzbekistani, Uzbek",
		"handle": "UZ"
	},
	{
		"name": "Vanuatu",
		"nationality": "Ni-Vanuatu, Vanuatuan",
		"handle": "VU"
	},
	{
		"name": "Vatican City State",
		"nationality": "Vatican",
		"handle": "VA"
	},
	{
		"name": "Venezuela (Bolivarian Republic of)",
		"nationality": "Venezuelan",
		"handle": "VE"
	},
	{
		"name": "Vietnam",
		"nationality": "Vietnamese",
		"handle": "VN"
	},
	{
		"name": "Virgin Islands (British)",
		"nationality": "British Virgin Island",
		"handle": "VG"
	},
	{
		"name": "Virgin Islands (U.S.)",
		"nationality": "U.S. Virgin Island",
		"handle": "VI"
	},
	{
		"name": "Wallis and Futuna",
		"nationality": "Wallis and Futuna, Wallisian or Futunan",
		"handle": "WF"
	},
	{
		"name": "Western Sahara",
		"nationality": "Sahrawi, Sahrawian, Sahraouian",
		"handle": "EH"
	},
	{
		"name": "Yemen",
		"nationality": "Yemeni",
		"handle": "YE"
	},
	{
		"name": "Zambia",
		"nationality": "Zambian",
		"handle": "ZM"
	},
	{
		"name": "Zimbabwe",
		"nationality": "Zimbabwean",
		"handle": "ZW"
	},
	{
		"name": "Åland Islands",
		"nationality": "Åland Island",
		"handle": "AX"
	},
];

const States = [
    {
        "name": "Alabama",
        "handle": "AL"
    },
    {
        "name": "Alaska",
        "handle": "AK"
    },
    {
        "name": "American Samoa",
        "handle": "AS"
    },
    {
        "name": "Arizona",
        "handle": "AZ"
    },
    {
        "name": "Arkansas",
        "handle": "AR"
    },
    {
        "name": "California",
        "handle": "CA"
    },
    {
        "name": "Colorado",
        "handle": "CO"
    },
    {
        "name": "Connecticut",
        "handle": "CT"
    },
    {
        "name": "Delaware",
        "handle": "DE"
    },
    {
        "name": "District Of Columbia",
        "handle": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "handle": "FM"
    },
    {
        "name": "Florida",
        "handle": "FL"
    },
    {
        "name": "Georgia",
        "handle": "GA"
    },
    {
        "name": "Guam",
        "handle": "GU"
    },
    {
        "name": "Hawaii",
        "handle": "HI"
    },
    {
        "name": "Idaho",
        "handle": "ID"
    },
    {
        "name": "Illinois",
        "handle": "IL"
    },
    {
        "name": "Indiana",
        "handle": "IN"
    },
    {
        "name": "Iowa",
        "handle": "IA"
    },
    {
        "name": "Kansas",
        "handle": "KS"
    },
    {
        "name": "Kentucky",
        "handle": "KY"
    },
    {
        "name": "Louisiana",
        "handle": "LA"
    },
    {
        "name": "Maine",
        "handle": "ME"
    },
    {
        "name": "Marshall Islands",
        "handle": "MH"
    },
    {
        "name": "Maryland",
        "handle": "MD"
    },
    {
        "name": "Massachusetts",
        "handle": "MA"
    },
    {
        "name": "Michigan",
        "handle": "MI"
    },
    {
        "name": "Minnesota",
        "handle": "MN"
    },
    {
        "name": "Mississippi",
        "handle": "MS"
    },
    {
        "name": "Missouri",
        "handle": "MO"
    },
    {
        "name": "Montana",
        "handle": "MT"
    },
    {
        "name": "Nebraska",
        "handle": "NE"
    },
    {
        "name": "Nevada",
        "handle": "NV"
    },
    {
        "name": "New Hampshire",
        "handle": "NH"
    },
    {
        "name": "New Jersey",
        "handle": "NJ"
    },
    {
        "name": "New Mexico",
        "handle": "NM"
    },
    {
        "name": "New York",
        "handle": "NY"
    },
    {
        "name": "North Carolina",
        "handle": "NC"
    },
    {
        "name": "North Dakota",
        "handle": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "handle": "MP"
    },
    {
        "name": "Ohio",
        "handle": "OH"
    },
    {
        "name": "Oklahoma",
        "handle": "OK"
    },
    {
        "name": "Oregon",
        "handle": "OR"
    },
    {
        "name": "Palau",
        "handle": "PW"
    },
    {
        "name": "Pennsylvania",
        "handle": "PA"
    },
    {
        "name": "Puerto Rico",
        "handle": "PR"
    },
    {
        "name": "Rhode Island",
        "handle": "RI"
    },
    {
        "name": "South Carolina",
        "handle": "SC"
    },
    {
        "name": "South Dakota",
        "handle": "SD"
    },
    {
        "name": "Tennessee",
        "handle": "TN"
    },
    {
        "name": "Texas",
        "handle": "TX"
    },
    {
        "name": "Utah",
        "handle": "UT"
    },
    {
        "name": "Vermont",
        "handle": "VT"
    },
    {
        "name": "Virgin Islands",
        "handle": "VI"
    },
    {
        "name": "Virginia",
        "handle": "VA"
    },
    {
        "name": "Washington",
        "handle": "WA"
    },
    {
        "name": "West Virginia",
        "handle": "WV"
    },
    {
        "name": "Wisconsin",
        "handle": "WI"
    },
    {
        "name": "Wyoming",
        "handle": "WY"
    },
];

const FundsSource = [
	{ name: "Personal Savings", handle: "personal_savings" },
	{ name: "Income", handle: "income" },
	{ name: "Property sale proceeds", handle: "property_sale" },
	{ name: "Inheritance", handle: "inheritance" },
	{ name: "Gift", handle: "gift", needDetails: true },
	{ name: 'Other', handle: 'other', needDetails: true },
];

const PurposeAndIntendedNature = [
	{ name: "General Investment", handle: "general_investment" },
	{ name: "Protection Against Volatility", handle: "volatility" },
	{ name: "Purchasing Precious Metals", handle: "precious_metals" },
	{ name: "Speculation", handle: "speculation" },
	{ name: "Diversification", handle: "diversification" },

];

const Occupations = [
	{
		name: "Administration, Business and Management",
		handle: "Administration, Business and Management"
	},
	{
		name: "Adult Services",
		handle: "Adult Services"
	},
	{
		name: "Animals, Land and Environment",
		handle: "Animals, Land and Environment"
	},
	{
		name: "Arms and Weapons",
		handle: "Arms and Weapons"
	},
	{
		name: "Cash Based Remittances or Exchange Services e.g. Bureaux De Change",
		handle: "Cash Based Remittances or Exchange Services e.g. Bureaux De Change"
	},
	{
		name: "Computing and ICT",
		handle: "Computing and ICT"
	},
	{
		name: "Construction and Building",
		handle: "Construction and Building"
	},
	{
		name: "Cultural Artefacts or Other Items of Archaeological, Historical, Cultural or Religious Significance or of Rare Scientific Value",
		handle: "Cultural Artefacts or Other Items of Archaeological, Historical, Cultural or Religious Significance or of Rare Scientific Value"
	},
	{
		name: "Dealers in High Value Goods e.g. Art, Antique Dealers, Luxury Cars, Private Aeroplane and Boat Dealers",
		handle: "Dealers in High Value Goods e.g. Art, Antique Dealers, Luxury Cars, Private Aeroplane and Boat Dealers"
	},
	{
		name: "Design, Arts and Crafts",
		handle: "Design, Arts and Crafts"
	},
	{
		name: "Education and Training",
		handle: "Education and Training"
	},
	{
		name: "Engineering",
		handle: "Engineering" },
	{
		name: "Financial Services",
		handle: "Financial Services" },
	{
		name: "Gambling",
		handle: "Gambling" },
	{
		name: "Garage Services",
		handle: "Garage Services" },
	{
		name: "Hairdressing and Beauty",
		handle: "Hairdressing and Beauty" },
	{
		name: "Helthcare & Pharmaceutical - if Product(s) are not Legal in the UK",
		handle: "Helthcare & Pharmaceutical - if Product(s) are not Legal in the UK" },
	{
		name: "Heritage, Culture and Libraries",
		handle: "Heritage, Culture and Libraries" },
	{
		name: "Hospitality, Catering and Tourism",
		handle: "Hospitality, Catering and Tourism" },
	{
		name: "Ivory or Other Items Related to Protected Species",
		handle: "Ivory or Other Items Related to Protected Species" },
	{
		name: "Languages",
		handle: "Languages"
	},
	{
		name: "Legal and Court Services",
		handle: "Legal and Court Services"
	},
	{
		name: "Manufacturing and Production",
		handle: "Manufacturing and Production"
	},
	{
		name: "Mining",
		handle: "Mining"
	},
	{
		name: "Mining (Crypto Currency)",
		handle: "Mining (Crypto Currency)"
	},
	{
		name: "Oil & Gas",
		handle: "Oil & Gas"
	},
	{
		name: "Performing Arts and Media",
		handle: "Performing Arts and Media"
	},
	{
		name: "Precious Metals",
		handle: "Precious Metals"
	},
	{
		name: "Print and Publishing, Marketing and Advertising",
		handle: "Print and Publishing, Marketing and Advertising"
	},
	{
		name: "Property / Real Estate",
		handle: "Property / Real Estate"
	},
	{
		name: "Property Services",
		handle: "Property Services"
	},
	{
		name: "Public Procurement",
		handle: "Public Procurement"
	},
	{
		name: "Retail and Customer Services",
		handle: "Retail and Customer Services"
	},
	{
		name: "Science, Mathematics and Statistics",
		handle: "Science, Mathematics and Statistics"
	},
	{
		name: "Shipping",
		handle: "Shipping"
	},
	{
		name: "Social Sciences and Religion",
		handle: "Social Sciences and Religion"
	},
	{
		name: "Social Work and Caring Services",
		handle: "Social Work and Caring Services"
	},
	{
		name: "Sport and Leisure",
		handle: "Sport and Leisure"
	},
	{
		name: "Tobacco Products",
		handle: "Tobacco Products"
	},
	{
		name: "Transport, Distribution and Logistics",
		handle: "Transport, Distribution and Logistics"
	},
];

const ExpectedVolumes = [
	{ name: "0-10k", handle: "0-10k" },
	{ name: "10-50k", handle: "10-50k" },
	{ name: "50k+", handle: "50k+" },
];

export { Countries, States, FundsSource, Occupations, ExpectedVolumes, PurposeAndIntendedNature };
